// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","mobileThreshold":"575px","applyTemplate":"PreviewTemplate_applyTemplate__2JDvV"};